import { Navigate, useLocation } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "./auth-provider";
import { t } from "@/i18n/de";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { loading, session, partner, signOut } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--text-3)",
          fontSize: 13,
        }}
      >
        {t.loading}
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Session bez partnera = zrušený přístup nebo vypršelý admin náhled.
  // Bez tohohle by portál vypadal jako partner bez jediné zakázky.
  if (!partner) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 14,
          color: "var(--text-3)",
          fontSize: 13,
          textAlign: "center",
          padding: 24,
        }}
      >
        <span>{t.noAccess}</span>
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => void signOut()}>
          {t.account.signOut}
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
